import {Box, HStack, Stack} from "native-base";
import {
    dbDateFormat,
    handleEmailBlur, handlePersonalIdBlur,
    handlePhoneBlur, isActive,
    isMobile, sendDataEvent
} from "../../../../../../services/Helpers";
import FormInput from "../../../../../common/FormInput";
import {t} from "../../../../../../services/i18n";
import AppText from "../../../../../common/AppText";
import {Colors} from "../../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import SharedTimepicker from "../../../../../common/SharedTimepicker";
import moment from "moment/moment";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {LEAD_SOURCE_SELECT, LEAD_STATUS_SELECT, STAFF_SELECT, USER_FIELDS} from "../../../../../../services/ConstHelper";
import CustomFieldSwitcherCreateModal from "../../../../../common/CustomFieldSwitcherCreateModal";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import React, {useEffect, useMemo, useState} from "react";
import {fetchApi} from "../../../../../../services/HTTP";
import usePermissions from "../../../../../../services/Permissions";
import {useToast} from "react-native-toast-notifications";
import {hideLoader, showLoader} from "../../../../../../redux/rootManagerSlice";
import {useDispatch, useSelector} from "react-redux";
import {flowOptions} from "../FlowOptions";
import {updateTempSelection} from "../../../../../../redux/stepperSlice";
import {optionalSteps} from "../StepOptions";
import {Roles} from "../../../../../../Configs/DatabaseConsts";

const PersonalDetails = (props) => {
    const {errors, touched, setFieldValue, values, handleChange, validationSchema, isChild, displayProps} = props
    const [userPhoneExist, setUserPhoneExist] = useState(null);
    const [userEmailExist, setUserEmailExist] = useState(null);
    const [userPersonalIdExist, setUserPersonalIdExist] = useState(null);
    const [staffMembers, setStaffMembers] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const requiredFields = useSelector((state) => state.box.box.settings?.[USER_FIELDS]);
    const stepper = useSelector((state) => state.stepper);
    const box = useSelector((state) => state.box.box);
    const currentUser = useSelector((state) => state.user.user);

    const sourceOptions = useMemo(() => box?.box_sources?.filter(isActive).map(source => ({ value: source.id, label: source.name })), [box])
    const statusOptions = useMemo(() => box?.box_statuses?.filter(isActive).map(status => ({ value: status.id, label: status.name })), [box])
    const convertLead = useMemo(() => stepper.name === flowOptions.BOOK_TO_HUG_CONVERT_LEAD, [stepper])
    const dispatch = useDispatch()
    const toast = useToast()
    const {has} = usePermissions()
    const genderOptions = [
        { value: '', label: t('not-specified') },
        { value: 'male', label: t('male') },
        { value: 'female', label: t('female') },
        { value: 'other', label: t('other') }
    ];

    useEffect(() => {
        if (!isInitialized && values) {
            if (values.email) {
                handleEmailBlur(values.email, setUserEmailExist, setFieldValue, values.lead_id);
            }
            if (values.personal_id) {
                handlePersonalIdBlur(values.personal_id, setUserPersonalIdExist, setFieldValue, values.lead_id);
            }
            if (values.phone) {
                handlePhoneBlur(values.phone, setUserPhoneExist, setFieldValue, values.lead_id);
            }
            setIsInitialized(true);
        }
    }, [values, isInitialized])

    useEffect(() => {
        convertLead && stepper.currStep === optionalSteps.LEAD_TO_CONVERT_PERSONAL_DETAILS && dispatch(updateTempSelection({email: values?.email, personal_id: values?.personal_id, lead_id: values?.lead_id, setFieldValue}));
    }, [stepper.currStep, values])

    useEffect(() => {
        if(has('addLeadOwner')) fetchStaffMembers();
    }, []);

    useEffect(() => {
        console.log('values', values)
        console.log('errors', errors)
    }, [errors, values])

    const onPhoneChange = (e) => {
        handleChange('phone')(e)
        setUserPhoneExist(null)
        if(e === '') {
            setFieldValue('phoneValidated', null)
        }
        if(!errors.phone || errors.phone === t('thisFieldIsMandatory')) {
            handlePhoneBlur(e, setUserPhoneExist, setFieldValue, values.lead_id)
        } else {
            setFieldValue('phoneValidated', false)
        }
    }

    const onEmailChange = (e) => {
        handleChange('email')(e)
        setUserEmailExist(null)
        if(e === '') {
            setFieldValue('emailValidated', null)
        }
        if(!errors.email || errors.email === t('thisFieldIsMandatory')) {
            handleEmailBlur(e, setUserEmailExist, setFieldValue, values.lead_id)
        } else {
            setFieldValue('emailValidated', false)
        }
    }

    const onPersonalIdChange = (e) => {
        handleChange('personal_id')(e)
        setUserPersonalIdExist(null)
        if(e === '') {
            setFieldValue('personalIdValidated', null)
        }
        if(!errors.personal_id) {
            handlePersonalIdBlur(e, setUserPersonalIdExist, setFieldValue)
        } else {
            setFieldValue('personalIdValidated', false)
        }
    }

    const onDateChange = (name, value) => {
        if (value && moment(value).isValid()) {
            const date = moment(value).format(dbDateFormat);
            setFieldValue(name, date);
        }
    }

    const restoreUserAndOpenProfile = async (usersId, setFunction) => {
        try {
            dispatch(showLoader())
            await fetchApi('usersBoxes/restoreUser', 'POST', { usersId }, false, true)
            setFunction(prev => ({...prev, deleted_at: null}))
            window.open(`/user-profile/${usersId}`, '_blank')
            dispatch(hideLoader())
        } catch (e) {
            dispatch(hideLoader())
            toast.show('restore error', { type: 'danger', duration: 2000 });
        }
    }

    const isRequiredField = (flow, field) => {
        return requiredFields?.[field]?.[`${flow?.toLowerCase()}Required`];
    }

    const isFieldRequired = (field) => isChild ? isRequiredField('child', field) : isRequiredField('member', field);

    const getPersonalIdError = () => {
        return values.personal_id && values.personal_id.match(/[^0-9]/g) ? t('non-numeric-chars') : ((touched.personal_id && errors.personal_id) ? errors.personal_id : null) ||
            userPersonalIdExist && (userPersonalIdExist.deleted_at ?
                    <HStack width={'max-content'} space={'0.3rem'}>
                        <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-personal-id-already-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                        <CustomButtonV2 onClick={() => restoreUserAndOpenProfile(userPersonalIdExist.user_fk, setUserPersonalIdExist)}
                                        iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                        override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                        />
                    </HStack>
                    :
                    <HStack width={'max-content'} space={'0.3rem'}>
                        <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-personal-id-already-exist-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                        <CustomButtonV2 onClick={() => window.open(`/user-profile/${userPersonalIdExist.user_fk}`, '_blank')}
                                        iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                        override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-access-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                        />
                    </HStack>

            )
    }

    const fetchStaffMembers = async () => {
        let staffMembersRes = await fetchApi('getStaffMembersOfBox', 'get', {exclude: [Object.keys(Roles).findIndex(x => x === Roles.COACH) + 1]}, false, true);
        staffMembersRes.forEach(staffMember => {
            staffMember.value = staffMember.id
            staffMember.label = `${staffMember.first_name} ${staffMember.last_name}`
            return staffMember
        })
        setStaffMembers(staffMembersRes);
        if(staffMembersRes.length === 1) {
            setFieldValue('users_boxes_owner_id', staffMembersRes[0].id)
        } else if (has('addLeadOwner')) {
            setFieldValue('users_boxes_owner_id', currentUser.id)
        }
    }

    const getEmailError = () => {
        return userEmailExist && (userEmailExist.deleted_at ?
            <HStack width={'max-content'} space={'0.3rem'}>
                <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-email-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                <CustomButtonV2 onClick={() => restoreUserAndOpenProfile(userEmailExist.user_fk, setUserEmailExist)}
                                iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                />
            </HStack>

            :
            <HStack width={'max-content'} space={'0.3rem'}>
                <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-email-already-exist-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                <CustomButtonV2 onClick={() => window.open(`/user-profile/${userEmailExist.user_fk}`, '_blank')}
                                iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-access-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                />
            </HStack>)

    }

    const getPhoneError = () => {
        return values.phone && values.phone.match(/[^0-9]/g) ? t('non-numeric-chars') : values.phone && values.phone.match(/[^0-9\+\-]/g) ? t('non-numeric-chars') : values.phone && (values.phone.length > 15 || values.phone.length < 5) ? t('phone-length-limit') : ((touched.phone && errors.phone) ? errors.phone : null) ||
            userPhoneExist && (userPhoneExist.deleted_at ?
                    <HStack width={'max-content'} space={'0.3rem'}>
                        <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-phone-already-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                        <CustomButtonV2 onClick={() => restoreUserAndOpenProfile(userPhoneExist.user_fk, setUserPhoneExist)}
                                        iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                        override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-restore-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                        />
                    </HStack>
                    :
                    <HStack width={'max-content'} space={'0.3rem'}>
                        <AppText color={Colors.newDesign.red} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-phone-already-exist-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                        <CustomButtonV2 onClick={() => window.open(`/user-profile/${userPhoneExist.user_fk}`, '_blank')}
                                        iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                        override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-access-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                        />
                    </HStack>

            )
    }

    const nameOnInvoiceField = has('invoiceName') ? (
        <Box width={isMobile ? '100%' : '33%'}>
            <FormInput
                infoTooltip={t('nameOnInvoiceTooltipCreateUser')}
                label={t('nameOnInvoice')}
                value={values.invoice_name}
                name={'first_name'}
                onChangeCallback={handleChange('invoice_name')}
                error={(touched.invoice_name && errors.invoice_name) ? errors.invoice_name : null}
                width={'100%'}
                containerProps={{mb: '1rem'}}
            />
        </Box>
    ) : null;

    const genderField = (
        <Box width={isMobile ? '100%' : '33%'}>
            <FormInput label={t('gender')} required={isFieldRequired('gender')}
                       width={'100%'} containerProps={{mb: '1rem'}}
                       error={(touched.gender && errors.gender) ? errors.gender : null}>
                <AdvanceSelect dontSort options={genderOptions} initValue={values.gender}
                               onChange={(option) => setFieldValue('gender', option.value ?? null)}
                               isError={(touched.gender && errors.gender) ? errors.gender : null}/>
            </FormInput>
        </Box>
    );

    return (
        <>
            <Stack direction={'column'} space={'5px'}>
                <Stack maxWidth={isMobile ? '100%' : '99%'} direction={isMobile ? 'column' : 'row'} space={'0.5rem'}>
                    {/* FULL NAME */}
                    <Box width={isMobile ? '100%' : '33%'}>
                        <FormInput
                            label={t('firstName')}
                            required
                            value={values.first_name}
                            name={'first_name'}
                            onChangeCallback={handleChange('first_name')}
                            error={(touched.first_name && errors.first_name) ? errors.first_name : null}
                            width={'100%'}
                            containerProps={{ mb: '1rem' }}
                        />
                    </Box>
                    <Box width={isMobile ? '100%' : '33%'}>
                        <FormInput
                            label={t('lastName')}
                            required={displayProps?.showCreateLeadFields ? isRequiredField('lead', 'last_name') : true}
                            value={values.last_name}
                            onChangeCallback={handleChange('last_name')}
                            error={(touched.last_name && errors.last_name) ? errors.last_name : null}
                            width={'100%'}
                            containerProps={{ mb: '1rem' }}
                        />
                    </Box>
                    {/* EMAIL */}
                    <Box width={isMobile ? '100%' : '33%'}>
                        <FormInput
                            infoTooltip={!displayProps?.showCreateLeadFields && t('emailTooltipCreateUser')}
                            label={t('email')}
                            required={isFieldRequired('email')}
                            value={values.email}
                            onChangeCallback={(e) => onEmailChange(e)}
                            width={'100%'}
                            containerProps={{ mb: '1rem' }}
                            error={getEmailError() || (touched.email && errors.email)}
                            type='email'
                        />
                    </Box>
                </Stack>
                <Stack maxWidth={isMobile ? '100%' : '99%'} direction={isMobile ? 'column' : 'row'} space={'0.5rem'}>
                        {/* PHONE */}
                        <Box width={isMobile ? '100%' : '33%'}>
                            <FormInput
                                label={t('phone')}
                                required={isFieldRequired('phone')}
                                value={values.phone}
                                onChangeCallback={(e) => onPhoneChange(e, setUserPhoneExist, 'phone')}
                                width={'100%'}
                                containerProps={{ mb: '1rem' }}
                                type='tel'
                                error={getPhoneError()}
                                helper={userPhoneExist &&
                                    <HStack width={'max-content'} space={'0.3rem'}>
                                        <AppText color={Colors.newDesign.darkGrey} variant={GlobalStyleAttributes.textVariants.heading4}>{t(`user-phone-already-exist-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>
                                        <CustomButtonV2 onClick={() => window.open(`/user-profile/${userPhoneExist.user_fk}`, '_blank')}
                                                        iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                                        override={({color}) => (<AppText variant={GlobalStyleAttributes.textVariants.heading4} color={color}>{t(`click-to-access-${isMobile ? 'mobile' : 'desktop'}`)}</AppText>)}
                                        />
                                    </HStack>}
                            />
                        </Box>
                        {/* ADDITIONAL PHONE */}
                        <Box width={isMobile ? '100%' : '33%'}>
                            <FormInput
                                    label={t('additionalPhone')}
                                    value={values.additional_phone}
                                    onChangeCallback={handleChange('additional_phone')}
                                    width={'100%'}
                                    containerProps={{ mb: '1rem' }}
                                    type='tel'
                                    error={(touched.additional_phone && errors.additional_phone) ? errors.additional_phone : null}
                                />
                        </Box>
                        {/* BIRTHDAY */}
                        <Box width={isMobile ? '100%' : '33%'}>
                            <FormInput label={t('birthday')} required={isFieldRequired('birthday')} width={'100%'} containerProps={{ mb: '1rem' }} error={(touched.birthday && errors.birthday) ? errors.birthday : null}>
                                <SharedTimepicker type={'date'} value={values.birthday ? moment(values.birthday, dbDateFormat) : null} onChange={(birthday) => onDateChange('birthday', birthday)} textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }} isError={(touched.birthday && errors.birthday) ? errors.birthday : null}/>
                            </FormInput>
                        </Box>
                    </Stack>
                <Stack maxWidth={isMobile ? '100%' : '99%'} direction={isMobile ? 'column' : 'row'} space={'0.5rem'}>

                {displayProps?.showCreateLeadFields &&
                    <>
                    {/* GENDER */}
                    {genderField}
                    {/*STATUS*/}
                    <Box width={isMobile ? '100%' : '33%'}>
                        <FormInput containerProps={{mb: '1rem'}} width={'100%'} label={t('status')}
                                       validationSchema={validationSchema} name={'status_fk'}
                                       error={(touched.status_fk && errors.status_fk) ? errors.status_fk : null}>
                            <AdvanceSelect menuShouldScrollIntoView={false} options={statusOptions}
                                               type={LEAD_STATUS_SELECT} initValue={values.status_fk}
                                               onChange={(option) => setFieldValue('status_fk', option.value ?? null)}
                                               isError={touched.status_fk && errors.status_fk}/>
                        </FormInput>
                    </Box>
                    {/*SOURCE*/}
                    <Box width={isMobile ? '100%' : '33%'}>
                        <FormInput containerProps={{mb: '1rem'}} label={t('source')} validationSchema={validationSchema}
                                       name={'source_fk'} width={'100%'}
                                       error={(touched.source_fk && errors.source_fk) ? errors.source_fk : null}>
                            <AdvanceSelect menuShouldScrollIntoView={false} options={sourceOptions}
                                               type={LEAD_SOURCE_SELECT} initValue={values.source_fk}
                                               onChange={(option) => setFieldValue('source_fk', option.value ?? null)}
                                               isError={touched.source_fk && errors.source_fk}/>
                        </FormInput>
                    </Box>
                    </>
                }
            </Stack>
                <Stack maxWidth={isMobile ? '100%' : '99%'} direction={isMobile ? 'column' : 'row'} space={'0.5rem'}>
                    {/*LEAD OWNER*/}
                    {has('addLeadOwner') && displayProps?.showCreateLeadFields &&
                        <Box width={isMobile ? '100%' : '33%'}>
                            <FormInput containerProps={{mb: '1rem'}} label={t('leadOwner')}
                                       validationSchema={validationSchema} name={'users_boxes_owner_id'} width={'100%'}
                                       error={(touched.users_boxes_owner_id && errors.users_boxes_owner_id) ? errors.users_boxes_owner_id : null}>
                                <AdvanceSelect options={staffMembers} type={STAFF_SELECT}
                                               initValue={values.users_boxes_owner_id}
                                               onChange={(option) => setFieldValue('users_boxes_owner_id', option?.value ?? null)}
                                               isClearable={true}
                                               isError={touched.users_boxes_owner_id && errors.users_boxes_owner_id}/>
                            </FormInput>
                        </Box>
                    }
                    {/* GENDER */}
                    {!displayProps?.showCreateLeadFields && genderField}
                    {/* PERSONAL ID */}
                    {!displayProps?.showCreateLeadFields && <FormInput
                        label={t('personal-id')}
                        required={isFieldRequired('personal_id')}
                        value={values.personal_id}
                        onChangeCallback={(e) => onPersonalIdChange(e)}
                        width={isMobile ? '100%' : '33%'}
                        containerProps={{mb: '1rem'}}
                        type='tel'
                        error={getPersonalIdError()}
                    />}
                    {/* KEY FOB ID */}
                    {has('burnChipActions') && !isMobile && !displayProps?.showCreateLeadFields &&
                        <FormInput
                        label={t('keyFobID')}
                        value={values.rfid}
                        onChangeCallback={handleChange('rfid')}
                        width={isMobile ? '100%' : '33%'}
                        containerProps={{mb: '1rem'}}
                        type='tel'
                        error={values.rfid && values.rfid.match(/[^0-9]/g) ? t('non-numeric-chars') : null}
                    />}
                    {/* NAME ON INVOICE — lead flow only (member flow gets its own row below) */}
                    {displayProps?.showCreateLeadFields && nameOnInvoiceField}
                </Stack>
                {/* NAME ON INVOICE — member flow (new row so Gender/Personal ID/Key Fob stay at 3 per row) */}
                {!displayProps?.showCreateLeadFields && nameOnInvoiceField &&
                    <Stack maxWidth={isMobile ? '100%' : '99%'} direction={isMobile ? 'column' : 'row'} space={'0.5rem'}>
                        {nameOnInvoiceField}
                    </Stack>
                }
                {/* CF */}
                {!!validationSchema?.fields?.customFields && <CustomFieldSwitcherCreateModal
                    customFields={values.customFields}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    errors={errors}
                    containerStyle={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '0.5rem',
                        boxSizing: 'border-box'
                    }}
                />}
                {/* COMMENT  */}
                {
                    displayProps?.showCreateLeadFields &&
                    <Box width={isMobile ? '100%' : '50%'}>
                        <FormInput label={t('comment')}
                                   width={'100%'}
                                   containerProps={{ mb: '1rem', style: {gridColumn: '1 / -1'} }}
                                   styleOverride={{padding: '0.5rem'}}
                                   rows={4}
                                   inputType={'multiline'}
                                   placeholder={t('lead-comment-placeholder')}
                                   value={values.comment}
                                   onChangeCallback={handleChange('comment')}
                        />
                    </Box>
                }
                {/* SUBSCRIPTIONS */}
                <FormInput containerProps={{ mb: '0' }} label={t('subscriptions')} width={'100%'} labelProps={{ mb: '0.5rem'}}>
                    <CustomCheckbox text={t('subscribe-mailing-list')} isChecked={values.allow_mailing_list === 'yes'} onChange={val => setFieldValue('allow_mailing_list', val ? 'yes' : 'no')}/>
                    <CustomCheckbox text={t('subscribe-sms')} isChecked={values.allow_sms === 'yes'} onChange={val => setFieldValue('allow_sms', val ? 'yes' : 'no')}/>
                </FormInput>
            </Stack>
        </>
    );
}

export default PersonalDetails